import { useFeatureFlagVariant } from "@/utils/kameleoon/useFeatureFlagVariant";
import { useBrand } from "@/contexts/cdpConfig";
export function useIsAdLeaderboardHidden() {
    const adLeaderboardHiddenVariant = "b";
    const brand = useBrand();
    const isHiddenForBrand = ["seloger", "immowelt"].includes(brand);
    const isAdLeaderboardHidden = useFeatureFlagVariant("cdp_hide_ad_leaderboard", adLeaderboardHiddenVariant);
    return isAdLeaderboardHidden && isHiddenForBrand;
}
